$(function () {
  /* ------------------------------------------
  /* # スムーススクロール
  /* ------------------------------------------ */
  $('a[href^="#"]:not([href="#"])').click(function () {
    var target = $($(this).attr("href")).offset().top;
    var headerHeight = $("#header").outerHeight();
    target -= headerHeight;
    $("html, body").animate(
      {
        scrollTop: target,
      },
      1000
    );
    return false;
  });

  /* ------------------------------------------
  /* # ハンバーガーメニュー main-page
  /* ------------------------------------------ */
  $(".burger-btn").click(function () {
    $(".bar, .g-nav").toggleClass("is-open");
  });

  $(".g-nav, .g-nav-item a").click(function () {
    $(".bar, .g-nav").removeClass("is-open");
  });

  /* ------------------------------------------
  /* # ハンバーガーメニュー sub-page
  /* ------------------------------------------ */
  $(".burger-btn").click(function () {
    $(".global-nav").toggleClass("is-open");
  });

  $(".global-nav, .close").click(function () {
    $(".global-nav").removeClass("is-open");
  });
  
  /* ------------------------------------------
  /* # ご購入はこちら
  /* ------------------------------------------ */
  $(".purchaseTrigger").on("click", function () {
    $(this).parent().next().addClass("is-open");
    $(this).next().addClass("is-open");
    $("body").addClass("is-open");
  });

  $(".purchase-close, .purchase-wrap").on("click", function () {
    $(".purchase-wrap").removeClass("is-open");
    $("body").removeClass("is-open");
  });

  $(".purchase-area").on("click", function (event) {
    event.stopPropagation();
  });

  /* ------------------------------------------
  /* # MORE
  /* ------------------------------------------ */
  $(".more").on("click", function () {
    $(this).toggleClass("is-active");
    $(this).parent().prev().slideToggle();
  });

  /* ------------------------------------------
  /* # FAQ
  /* ------------------------------------------ */
  $(".faq-item").on("click", function () {
    $(this).children(".question").toggleClass("is-active");
    $(this).children(".answer").slideToggle();
  });

  /* ------------------------------------------
  /* # fadeUp
  /* ------------------------------------------ */

  function fadeUpAnime() {
    if (window.matchMedia("(max-width: 750px)").matches) {
      var distance = 100;
    } else {
      var distance = 150;
    }
    $(".fadeUpTrigger").each(function () {
      var elemPos = $(this).offset().top + distance;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight) {
        $(this).addClass("fadeUp");
      }
    });
  }

  $(window).scroll(function () {
    fadeUpAnime();
  });
});
